var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vertical icon-button",staticStyle:{"justify-content":"center","align-items":"center"},on:{"click":_vm.onClick}},[_vm._t("default"),_vm._v(" "),_c('span',{staticClass:"icon-text noselect"},[_vm._v(_vm._s(_vm.text))]),_vm._v(" "),_c('div',{staticClass:"selected"})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7fca2984","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/IconButton.vue
// module id = 1750
// module chunks = 3 9